import React from "react";

import {
  AccountBalanceRounded,
  CloseRounded,
  DirectionsBusRounded,
  SchoolRounded,
  SwapHorizRounded,
  SyncRounded,
} from "@mui/icons-material";
import { AccordionDetails, AccordionSummary, Box, DialogContent } from "@mui/material";

import useFirebase from "../../../../../config/context/firebaseContext";

import useBus from "../../context";

import { ModalTransition } from "../../../../../components/ModalTransition";
import PageHeader from "../../../../../components/PageHeader";

import { ModalBaseType } from "../../../../../types/common";

import { WideDialog } from "../../../../../components/MainModalSimple/styles";
import MainText from "../../../../../components/MainText";
import DepartTable from "../DepartTable";
import { StyledAccordion } from "../Departs/styles";

export type ModalViewBusScheduleProps = ModalBaseType & { busId: string };

export default function ModalViewBusSchedule({ onClose, busId }: ModalViewBusScheduleProps) {
  const { analyticLog } = useFirebase();

  const { busSchedules } = useBus();

  const [open, setOpen] = React.useState(true);

  const ScrollBoxRef = React.useRef(null);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  React.useEffect(() => {
    analyticLog("click_other_bus", { bus: busId });
  }, []);

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent sx={{ overflowY: "scroll" }} ref={ScrollBoxRef}>
        <PageHeader
          size="subtitle"
          title={"Horários"}
          rightIcon={<CloseRounded />}
          onRightAction={handleClose}
        />

        <StyledAccordion
          key={busId}
          accordioncolor={busSchedules?.[busId]?.color}
          expanded={true}
          sx={{ overflow: "hidden" }}
        >
          <AccordionSummary>
            <Box
              width={"100%"}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box display={"flex"}>
                {busId.includes("direto") ? (
                  <SwapHorizRounded style={{ marginRight: 10 }} />
                ) : busId.includes("inverso") ? (
                  <SyncRounded style={{ marginRight: 10 }} />
                ) : busId.includes("reitoria") ? (
                  <AccountBalanceRounded style={{ marginRight: 10 }} />
                ) : busId.includes("cet") ? (
                  <SchoolRounded style={{ marginRight: 10 }} />
                ) : (
                  <DirectionsBusRounded style={{ marginRight: 10 }} />
                )}
                <MainText color="white">{busSchedules?.[busId]?.name}</MainText>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ overflowX: "auto" }}>
            <DepartTable busId={busId} scheduleBus={busSchedules?.[busId]?.schedule} showFullHour />
          </AccordionDetails>
        </StyledAccordion>
      </DialogContent>
    </WideDialog>
  );
}
